const deleteClientUseCase = (repository) => async (id) => {
    return await repository(id);
}

export default deleteClientUseCase;